import React from 'react';
import { ClipboardListIcon, BookOpenIcon, UsersIcon, FileTextIcon } from 'lucide-react';
export function ServiceIncluded() {
  const items = [{
    title: 'Team assessment',
    description: "Anonymous survey that shows you where your team actually stands: who's effective, who's struggling, and where the gaps are.",
    icon: <ClipboardListIcon className="w-6 h-6" data-id="element-306" data-mp="2shol8ypwzyrb" />
  }, {
    title: 'Customized curriculum',
    description: "Six sessions over six weeks, built around your team's real work. Not slides and theory. Hands-on skills applied between sessions.",
    icon: <BookOpenIcon className="w-6 h-6" data-id="element-307" data-mp="2dnjocao9ycd2" />
  }, {
    title: 'AI champion development',
    description: "We identify your strongest adopters and give them the tools to keep the team's momentum going after the program ends.",
    icon: <UsersIcon className="w-6 h-6" data-id="element-308" data-mp="bssrz8f6lfoc" />
  }, {
    title: 'Follow-up report',
    description: 'A summary of where the team started, what changed, and recommendations for what to focus on next.',
    icon: <FileTextIcon className="w-6 h-6" data-id="element-309" data-mp="2ratrgqxpxcfn" />
  }];
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-310" data-mp="2r90kfaj70q74">
      <div className="max-w-7xl mx-auto" data-id="element-311" data-mp="2dd57dlbh69bn">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-312" data-mp="2hcnwktabx6ka">
          What's included
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-313" data-mp="3528dz7qu3vrg">
          {items.map((item, index) => <div key={index} className="bg-white p-10 rounded-lg shadow-sm border-t-4 border-brand-orange flex flex-col" data-id="element-314" data-mp="3a13650aoywo8" data-mpi={index}>
              <div className="w-14 h-14 bg-brand-orange/10 rounded-full flex items-center justify-center mb-8 text-brand-orange" data-id="element-315" data-mp="30b9szuuwi9hv">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-4" data-id="element-316" data-mp="3ss2qfo78rib6">
                {item.title}
              </h3>
              <p className="text-brand-gray text-lg leading-relaxed flex-grow" data-id="element-317" data-mp="6j6yqjl79m4r">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}